import React from 'react';
export const Footer = () => {
  return <footer className="bg-wellness-forest text-wellness-cream py-12 border-t border-wellness-sage/20" data-id="element-26">
      <div className="container mx-auto px-6 max-w-6xl text-center" data-id="element-27">
        <h3 className="font-serif text-2xl mb-6 italic text-wellness-gold" data-id="element-28">
          The Menopause Belly Reset
        </h3>

        <div className="flex flex-wrap justify-center gap-6 font-sans text-sm text-wellness-cream/60 mb-8" data-id="element-29">
          <a href="#" className="hover:text-wellness-cream transition-colors" data-id="element-30">
            Terms & Conditions
          </a>
          <a href="#" className="hover:text-wellness-cream transition-colors" data-id="element-31">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-wellness-cream transition-colors" data-id="element-32">
            Contact Support
          </a>
        </div>

        <p className="font-sans text-xs text-wellness-cream/40 max-w-2xl mx-auto leading-relaxed" data-id="element-33">
          Disclaimer: The information provided is for educational purposes only
          and is not intended as medical advice. Consult with your healthcare
          provider before beginning any new diet or lifestyle protocol.
        </p>

        <p className="font-sans text-xs text-wellness-cream/40 mt-6" data-id="element-34">
          &copy; {new Date().getFullYear()} The Menopause Belly Reset. All
          rights reserved.
        </p>
      </div>
    </footer>;
};